import React from "react";
import Select from "react-select";


const customStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: "45px",
        borderRadius: "8px",
        borderColor: state.isFocused ? "#185FA5" : "#ccc",
        boxShadow: state.isFocused ? "0 0 0 1px #185FA5" : "none",
        "&:hover": {
            borderColor: "#185FA5",
        },
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};
const SelectorField = ({ options = [], value = "", onChange, isDisabled = false, isLoading = false, label = "" }) => {
    const selectedValue = options.find((opt) => opt.value === value) || null;
    return (
        <div style={{ marginTop: "10px" }}>
            <label style={{ fontWeight: "bold", marginBottom: "6px", display: "block" }}>{label} *</label>

            <Select
                value={selectedValue}
                placeholder={label}
                isDisabled={isDisabled}
                isLoading={isLoading}
                onChange={(selectedOption) => onChange(selectedOption)}
                options={options}
                styles={customStyles}
                isClearable
            />
        </div>
    );
};

export default SelectorField;